<div id="presentation-app" *ngIf="hymn">
  <div id="presentation-content" #content doubletap (doubletap)="onDoubleTap()" swipeGesture [axis]="'x'" (swipeleft)="onSwipeNext()" (swiperight)="onSwipePrevious()">

    <div *ngIf="hymn" class="presentationText text-stroked" [style.font-family]="presentFontFamily || null" [style.font-weight]="presentFontWeight || null">
      <mat-card class="hymnTitle mat-card-main mat-card-centered">
        <mat-card-content [style.font-size]="textSizeStyle">
          <p id="hymnTitle" class="presentationText" #hymnTitle>{{translation.hymn}} {{hymn.hymnNumber}} - {{hymn.title}}</p>
        </mat-card-content>
      </mat-card>

      <mat-card id="presentationTextCard" class="mat-card-centered mat-card-main" [style.font-size]="textSizeStyle">
        <mat-card-header>
          <i id="verseNumber" class="presentationText" #verseNumber>
            {{(activeVerse != 'R'? translation.verse + ' ' + activeVerse : translation.refrain) + (visibleSectionIndex > 0 ? ' ('+translation.continued+')':'')}}
          </i>
        </mat-card-header>
        <mat-card-content>
          <div id="hymnText" class="presentationText" #hymnText>
            <ng-container *ngIf="visibleVerseSections && visibleVerseSections.get(visibleSectionIndex)">
              <ng-container *ngFor="let line of visibleVerseSections.get(visibleSectionIndex)?.lines; let i = index">
                <p class="verse-line" [style.font-size]="textSizeStyle">{{line}}</p>
              </ng-container>
            </ng-container>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <mat-toolbar color="primary" class="sticky-toolbar-bottom">
    @if (!sidenavService.hymnListOpen) {
      <div class="padding-safe-left"></div>
    }

    <button (click)="toggleListSidenav()" mat-icon-button>
      <mat-icon>menu</mat-icon>
    </button>

    <span class="toolbar-fill-remaining-space"></span>

    <button
      *ngIf="!layoutService.singleView"
      [style.visibility]="(visibleSectionIndex > 0 || activeVerseIndex > 0)? 'visible' : 'hidden'"
      mat-mini-fab (click)="navigateLeft()" class="my-fab navigate">
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>

    <ng-container *ngFor="let verse of hymn.verses; let i = index" style="overflow-x: scroll">
      <ng-container *ngIf="hymn.hasChorus && i == 1">
        <button mat-mini-fab (click)="clickVerse('R')" [class]="activeVerse==='R'? 'my-fab-active' : 'my-fab'">R</button>
      </ng-container>

      <button mat-mini-fab (click)="clickVerse((i+1).toString())" [class]="activeVerse===((i+1).toString())? 'my-fab-active' : 'my-fab'">{{(i+1).toString()}}</button>
      <br>
    </ng-container>

    <button
      *ngIf="!layoutService.singleView"
      [style.visibility]="((visibleSectionIndex < visibleVerseSections.size - 1) || (activeVerseIndex < (verseList.length - 1)))? 'visible' : 'hidden'"
      mat-mini-fab (click)="navigateRight()" class="my-fab navigate">
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>

    <span class="toolbar-fill-remaining-space"></span>

    <ng-container *ngIf="!layoutService.singleView">

      <button *ngIf="settingService.isFavoriteOrHymnToLearn(hymn.hymnNumber)" (click)="settingService.removeHymnFromFavoritesAndToLearn(hymn);" mat-icon-button>
        <mat-icon *ngIf="settingService.isFavorite(hymn.hymnNumber)">favorite</mat-icon>
        <mat-icon *ngIf="settingService.isHymnToLearn(hymn.hymnNumber)">bookmark</mat-icon>
      </button>

      <button *ngIf="!settingService.isFavoriteOrHymnToLearn(hymn.hymnNumber)" [matMenuTriggerFor]="favoriteMenu" mat-icon-button>
        <mat-icon>favorite_border</mat-icon>
      </button>

      <mat-menu #favoriteMenu="matMenu">
        <button (click)="settingService.toggleFavorite(hymn);" mat-menu-item>
          <mat-icon>favorite_border</mat-icon>
          <span>{{translation.add_to_favorites}}</span>
        </button>
        <button (click)="settingService.toggleHymnToLearn(hymn);" mat-menu-item>
          <mat-icon>bookmark_border</mat-icon>
          <span>{{translation.add_to_hymns_to_learn}}</span>
        </button>
      </mat-menu>

      <button mat-icon-button (click)="hymnSelectionService.dialpad()">
        <mat-icon>dialpad</mat-icon>
      </button>

      <button mat-icon-button [matMenuTriggerFor]="shuffleMenu">
        <mat-icon>shuffle</mat-icon>
      </button>

      <mat-menu #shuffleMenu="matMenu">
        <button [disabled]="settingService.getFavorites().length < 2" mat-menu-item (click)="hymnSelectionService.goToRandomHymn(true)">
          <mat-icon>shuffle</mat-icon>
          <span>{{translation.random_favorite}}</span>
        </button>
        <button mat-menu-item (click)="hymnSelectionService.goToRandomHymn(false)">
          <mat-icon>shuffle</mat-icon>
          <span>{{translation.random_hymn}}</span>
        </button>
      </mat-menu>
    </ng-container>

    <button mat-icon-button [matMenuTriggerFor]="presentMenu">
      <mat-icon>more_vert</mat-icon>
    </button>

    <mat-menu #presentMenu="matMenu">
      <ng-container *ngIf="layoutService.singleView">
        <button *ngIf="hymn && hymn.hasMidi" (click)="midiService.playing? midiService.stop() : midiService.playMidi(hymn, settingService.getInstruments(), hymn.verses.length)" mat-menu-item>
          <mat-icon *ngIf="!midiService.playing">music_note</mat-icon>
          <span *ngIf="!midiService.playing">{{translation.listen}}</span>
          <mat-icon *ngIf="midiService.playing">stop</mat-icon>
          <span *ngIf="midiService.playing">{{translation.stop}}</span>
        </button>

        <button (click)="settingService.toggleFavorite(hymn);" mat-menu-item>
          <mat-icon *ngIf="!settingService.isFavorite(hymn.hymnNumber)">favorite_border</mat-icon>
          <span *ngIf="!settingService.isFavorite(hymn.hymnNumber)">{{translation.add_to_favorites}}</span>
          <mat-icon *ngIf="settingService.isFavorite(hymn.hymnNumber)">favorite</mat-icon>
          <span *ngIf="settingService.isFavorite(hymn.hymnNumber)">{{translation.remove_from_favourites}}</span>
        </button>

        <button (click)="settingService.toggleHymnToLearn(hymn);" mat-menu-item>
          <mat-icon *ngIf="!settingService.isHymnToLearn(hymn.hymnNumber)">bookmark_border</mat-icon>
          <span *ngIf="!settingService.isHymnToLearn(hymn.hymnNumber)">{{translation.add_to_hymns_to_learn}}</span>
          <mat-icon *ngIf="settingService.isHymnToLearn(hymn.hymnNumber)">bookmark</mat-icon>
          <span *ngIf="settingService.isHymnToLearn(hymn.hymnNumber)">{{translation.remove_from_hymns_to_learn}}</span>
        </button>

        <button mat-menu-item (click)="hymnSelectionService.dialpad()">
          <mat-icon>dialpad</mat-icon>
          <span>{{translation.go_to_hymn_number}}</span>
        </button>

        <button [disabled]="settingService.getFavorites().length < 2" mat-menu-item (click)="hymnSelectionService.goToRandomHymn(true)">
          <mat-icon>shuffle</mat-icon>
          <span>{{translation.random_favorite}}</span>
        </button>

        <button mat-menu-item (click)="hymnSelectionService.goToRandomHymn(false)">
          <mat-icon>shuffle</mat-icon>
          <span>{{translation.random_hymn}}</span>
        </button>
      </ng-container>

      <button (click)="settingService.setHymnViewMode()" [routerLink]="['/'+translation.path_hymn, hymn.hymnNumber]" mat-menu-item>
        <mat-icon>devices</mat-icon>
        <span>{{translation.read_mode}}</span>
      </button>

      <button (click)="changeFontSize()" mat-menu-item>
        <mat-icon>text_fields</mat-icon>
        <span>{{translation.change_font_size}}</span>
      </button>

      <button *ngIf="layoutService.isNotBrowser()" mat-menu-item (click)="shareService.shareHymn(this.hymn)">
        <mat-icon>share</mat-icon>
        <span>{{translation.share_hymn}} {{hymn.hymnNumber}}</span>
      </button>

      <button *ngIf="layoutService.fullscreenSupported()" (click)="toggleFullscreen()" mat-menu-item>
        <mat-icon>{{layoutService.fullscreen? 'fullscreen_exit' : 'fullscreen'}}</mat-icon>
        <span>{{layoutService.fullscreen? translation.fullscreen_exit : translation.fullscreen}}</span>
      </button>

      <button *ngIf="!layoutService.singleView" mat-menu-item (click)="modalService.openDialog('shortcuts', {'hymnViewMode': 'presentation'})">
        <mat-icon>keyboard_command_key</mat-icon>
        <span>{{translation.shortcuts}}</span>
      </button>

      <button (click)="toggleSettingSidenav()" mat-menu-item>
        <mat-icon>settings</mat-icon>
        <span>{{translation.settings}}</span>
      </button>

      <button mat-menu-item (click)="shareService.suggestCorrection(this.hymn)">
        <mat-icon>create</mat-icon>
        <span>{{translation.suggest_correction}}</span>
      </button>

      <button *ngIf="!layoutService.singleView && layoutService.isNotBrowser()" mat-menu-item (click)="shareService.shareApp();">
        <mat-icon>share</mat-icon>
        <span>{{translation.share_app}}</span>
      </button>
    </mat-menu>

    @if (!settingService.settingsOpened) {
      <div class="padding-safe-right"></div>
    }
  </mat-toolbar>

  <app-music-control mode="presentation" class="music-control-menu"></app-music-control>
</div>
